import { gql } from '@apollo/client'

import { CONFIRMATION_MODALITIES } from 'features/Services/components/ConfirmationModalities/constants'

export const sanitizeService = (id: TSFixMe, serviceData: TSFixMe): TSFixMe => {
  if (id && serviceData && serviceData.service && id === serviceData.service.id) {
    return serviceData.service
  }

  return undefined
}

export const getConfirmationModalitiesAsArray = (modalities: TSFixMe): TSFixMe => {
  let result: TSFixMe = []

  if (modalities[CONFIRMATION_MODALITIES.PAID]) {
    result = [...result, CONFIRMATION_MODALITIES.PAID]
  }

  if (modalities[CONFIRMATION_MODALITIES.RESERVED]) {
    result = [...result, CONFIRMATION_MODALITIES.RESERVED]
  }

  if (modalities[CONFIRMATION_MODALITIES.FACEBOOK]) {
    result = [...result, CONFIRMATION_MODALITIES.FACEBOOK]
  }

  return result
}

export const getDayLabel = (day: TSFixMe): TSFixMe => {
  switch (day) {
    case 1:
      return 'monday'
    case 2:
      return 'tuesday'
    case 3:
      return 'wednesday'
    case 4:
      return 'thursday'
    case 5:
      return 'friday'
    case 6:
      return 'saturday'
    case 7:
      return 'sunday'
  }
  return 'invalid day'
}

export const resolvers = {
  Mutation: {
    updateServiceIsActive(_root: TSFixMe, { serviceId, isActive }: TSFixMe, { cache }: TSFixMe): TSFixMe {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Service',
          id: serviceId
        }),
        fragment: gql`
          fragment ServiceIsActive on Service {
            isActive
          }
        `,
        data: {
          __typename: 'Service',
          isActive
        }
      })
      return null
    }
  }
}
